module.exports = __webpack_public_path__ + "static/media/fresh_bg.9511dd91.jpg";